import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.sass']
})
export class CreateUserComponent implements OnInit {

  public statusRadio=[false,false];
  public statusOn=[];
  public name;
  public email;
  public lastName;
  public account;
  public phoneNumber;
  public rolesList;
  public sendRole;
  public banList:object;
  public role;
  public subscribersList:object;
  public defaultSubscriber:number;
  @Output() nextStep = new EventEmitter<number>();
  @Output() updateName = new EventEmitter<any>();
  @Output() updateLastName = new EventEmitter<any>();
  @Output() updateEmail = new EventEmitter<any>();
  @Output() updateNum = new EventEmitter<number>();
  @Output() updateIdRole = new EventEmitter<any>();
  @Output() updateAccount = new EventEmitter<any>();
  @Output() updateRole = new EventEmitter<any>();
  
  constructor(public global:GlobalService,private services: Service,private loadingScreenService :LoadingScreenService) { }

  ngOnInit() {
    this.loadData();
  }
  loadData(){
    this.defaultSubscriber= parseInt(atob(sessionStorage.getItem("defaultSubscriber")));
    if(sessionStorage.getItem("listData")==null){
      this.loadingScreenService.startLoading();
      this.services.getSubscriberList("", "", sessionStorage.getItem("token"), 1, 500).subscribe(data => {
        if(data.hasError ==false){
          this.loadingScreenService.stopLoading();
          this.banList=data.accounts;
          sessionStorage.setItem("listData",btoa(JSON.stringify(data)));
        }
        else{
          this.loadData();
        }
      });
      this.services.rolesList().subscribe(data =>{
        this.rolesList=data;
        for(let i=0;i < this.rolesList.length;i++){
          this.statusOn[i]=false;
        }
      });
    }
    else{
      this.banList=JSON.parse(atob(sessionStorage.getItem("listData"))).accounts;
      this.services.rolesList().subscribe(data =>{
        this.loadingScreenService.stopLoading();
        this.rolesList=data;
        for(let i=0;i < this.rolesList.length;i++){
          this.statusOn[i]=false;
        }
      });
    }
  }
  changeAccount(event:Event){
    let index =parseInt(event.target["selectedIndex"])-1;
    // this.name=this.banList[index].subscribers[0].name;
    // this.lastName=this.banList[index].subscribers[0].lastName;}
    this.subscribersList=this.banList[index].subscribers;
    this.phoneNumber=this.banList[index].subscribers[0].subscriber;
  }
  changeType(id:number,IdRole,name){
    for(let i=0;i < this.statusOn.length;i++){
      this.statusOn[i]=false;
      this.statusRadio[i]=false;
    }
    this.statusRadio[id]=true;
    this.statusOn[id]=true;
    this.sendRole = IdRole;
    this.role=name;
  }
  continue(){
    if(this.validateForm()){
      this.nextStep.emit(2);
      this.updateName.emit(this.name);
      this.updateLastName.emit(this.lastName);
      this.updateEmail.emit(this.email);
      this.updateNum.emit(this.phoneNumber);
      this.updateAccount.emit(this.account);
      this.updateIdRole.emit(this.sendRole);
      this.updateRole.emit(this.role);
    }
  }
  validateForm() {
    let sw=false;
    for(let i=0;i < this.statusOn.length;i++){
      if(this.statusOn[i]==true){
        sw=true;
      }
    }
    if (this.account === ''|| this.account === undefined) {
      this.global.notif("Debe seleccionar un número de cuenta.");
      return false;
    }
    else if (this.phoneNumber === ''|| this.phoneNumber === undefined) {
      this.global.notif("Debe seleccionar un número de teléfono.");
      return false;
    }
    else if (this.name === ''|| this.name === undefined) {
        this.global.notif("Debe colocar el nombre de usuario.");
        return false;
    }
    else if (this.lastName === '' || this.lastName === undefined) {
        this.global.notif("Debe colocar su apellido.");
        return false;
    }
    else if (this.email === '' || this.email === undefined) {
      this.global.notif("Escriba su correo electrónico.");
      return false;
    }
    else if(this.global.validarEmail(this.email)==false){
      this.global.notif("Escriba un correo electrónico válido.");
      return false;
    }
    else if(atob(sessionStorage.getItem("email"))==this.email){
      this.global.notif("No esta permitido registrar el nuevo usuario con el correo del administrador.");
      return false;
    } 
    else if (this.phoneNumber === '' || this.phoneNumber === null) {
      this.global.notif('Debe colocar un número teléfonico.');
      return false;
    }
    else if (this.phoneNumber.length !== 10) {
      this.global.notif('El número de teléfono debe ser en un formato válido.');
      return false;
    }
    else if(sw==false){
      this.global.notif('Debe selecionar un rol para el usuario.');
      return false;
    }
    return true;
  }
}
